var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2917 11.3333C15.2917 10.9882 15.0119 10.7083 14.6667 10.7083H11.3334C10.9882 10.7083 10.7084 10.9882 10.7084 11.3333V14.6667C10.7084 15.0119 10.9882 15.2917 11.3334 15.2917C11.6786 15.2917 11.9584 15.0119 11.9584 14.6667V12.8422L15.0581 15.942C15.3022 16.186 15.6979 16.186 15.942 15.942C16.1861 15.6979 16.1861 15.3021 15.942 15.0581L12.8423 11.9583H14.6667C15.0119 11.9583 15.2917 11.6785 15.2917 11.3333Z",
    fill: "#656579"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7084 11.3333C20.7084 10.9882 20.9882 10.7083 21.3334 10.7083H24.6667C25.0119 10.7083 25.2917 10.9882 25.2917 11.3333V14.6667C25.2917 15.0119 25.0119 15.2917 24.6667 15.2917C24.3215 15.2917 24.0417 15.0119 24.0417 14.6667V12.8422L20.942 15.942C20.6979 16.186 20.3022 16.186 20.0581 15.942C19.814 15.6979 19.814 15.3021 20.0581 15.0581L23.1578 11.9583H21.3334C20.9882 11.9583 20.7084 11.6785 20.7084 11.3333Z",
    fill: "#656579"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2917 24.6667C15.2917 25.0119 15.0119 25.2917 14.6667 25.2917H11.3334C10.9882 25.2917 10.7084 25.0119 10.7084 24.6667V21.3333C10.7084 20.9882 10.9882 20.7083 11.3334 20.7083C11.6786 20.7083 11.9584 20.9882 11.9584 21.3333V23.1578L15.0581 20.0581C15.3022 19.814 15.6979 19.814 15.942 20.0581C16.1861 20.3021 16.1861 20.6979 15.942 20.942L12.8423 24.0417H14.6667C15.0119 24.0417 15.2917 24.3215 15.2917 24.6667Z",
    fill: "#656579"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7084 24.6667C20.7084 25.0119 20.9882 25.2917 21.3334 25.2917H24.6667C25.0119 25.2917 25.2917 25.0119 25.2917 24.6667V21.3333C25.2917 20.9882 25.0119 20.7083 24.6667 20.7083C24.3215 20.7083 24.0417 20.9882 24.0417 21.3333V23.1578L20.942 20.0581C20.6979 19.814 20.3022 19.814 20.0581 20.0581C19.814 20.3021 19.814 20.6979 20.0581 20.942L23.1578 24.0417H21.3334C20.9882 24.0417 20.7084 24.3215 20.7084 24.6667Z",
    fill: "#656579"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandButton);
export default __webpack_public_path__ + "static/media/expand-button.293b20f2370f277218869112a227f355.svg";
export { ForwardRef as ReactComponent };